/** 已确认的历史演示记录；按标识筛除，绝不清空整组业务数据。 */
export const CONFIRMED_DEMO_CLEANUP_MARKER = 'changfa_confirmed_demo_cleanup_v1';

const DEMO_PURCHASE_ORDER_IDS = new Set(['CG20260829002', 'CG20260828001']);
const DEMO_RETURN_IDS = new Set(['1', '2', '3']);
const DEMO_INBOUND_NOS = new Set([
  'RK20260830006',
  'RK20260810001',
  'RK20260808002',
  'RK20260805001',
  'RK20260805002',
]);

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

type StoredRow = Record<string, unknown>;

function filterStoredArray(storage: StorageLike, key: string, shouldRemove: (row: StoredRow) => boolean): number {
  const raw = storage.getItem(key);
  if (!raw) return 0;
  try {
    const value: unknown = JSON.parse(raw);
    if (!Array.isArray(value)) return 0;
    const next = value.filter((row) => !row || typeof row !== 'object' || !shouldRemove(row as StoredRow));
    const removed = value.length - next.length;
    if (removed > 0) storage.setItem(key, JSON.stringify(next));
    return removed;
  } catch {
    // 数据不是预期的 JSON 时保留原样，不能因为清理而损坏未知数据。
    return 0;
  }
}

/**
 * 每个浏览器仅运行一次。只移除服务器盘点到的演示单据；后来新增的数据保持不变。
 */
export function cleanupConfirmedDemoData(storage: StorageLike): number {
  if (storage.getItem(CONFIRMED_DEMO_CLEANUP_MARKER) === 'done') return 0;

  const removed = [
    filterStoredArray(storage, 'changfa_purchase_orders', (row) => DEMO_PURCHASE_ORDER_IDS.has(String(row.id))),
    filterStoredArray(storage, 'changfa_returns', (row) => DEMO_RETURN_IDS.has(String(row.id ?? row.returnId))),
    filterStoredArray(storage, 'changfa_purchase_details', (row) => DEMO_INBOUND_NOS.has(String(row.inboundNo ?? row.inboundId))),
  ].reduce((sum, count) => sum + count, 0);

  storage.setItem(CONFIRMED_DEMO_CLEANUP_MARKER, 'done');
  return removed;
}
